import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { ColumnData } from '../interface/interface';
import { useEffect, useState } from 'react';

export const useToDefineCols = (
  cols: Array<ColumnData>,
): Array<Array<ColumnDef<any, any>>> => {
  const helper = createColumnHelper<any>();
  const [columns, setCols] = useState<Array<ColumnDef<any, any>>>([]);

  useEffect(() => {
    setCols(() =>
      cols.map((c) =>
        helper.accessor(c.key, {
          id: c.key,
          cell: c.cell,
          header: c.header,
          enableSorting: c.isSortable,
        }),
      ),
    );
  }, []);

  return [columns];
};
